import { useUpdatedDD } from "../updateDDToState";
import {
  DDSortType,
  useSortedFeaturesWithCrs,
} from "fe-common/hooks/sortFeaturesWithCrs";
import { useDiagnosticNavigation } from "../useDiagnosticNavigation";
import { DEFAULT_SORT, pathOptions } from "./consts";
import { usePatientCase } from "../usePatientCase";

export const useDiseasesSections = (
  ddSortType: DDSortType = DDSortType.BySuspicionIndex,
  forceDD: boolean = false,
  includeCitations: boolean = true,
) => {
  const {
    resetExpandedDiseases,
    setScrollLocation,
  } = useDiagnosticNavigation();

  const { data: ddData, loading, ddStatus } = useUpdatedDD(
    pathOptions,
    () => {
      resetExpandedDiseases();
      setScrollLocation(0);
    },
    forceDD,
    includeCitations,
  );

  const {
    clinicalReasoning: crs,
    clustersToConsider,
    strengthForSortType,
    strength,
  } = ddData || {};

  const ddStrength =
    strengthForSortType?.find((s) => s.sortType === DEFAULT_SORT)?.strength ||
    strength;

  const {
    patientCase: {
      diseasesToIncludeInPlan,
      diseasesToRemoveFromPlan,
      diseasesToAdd,
    },
  } = usePatientCase();

  const featuresSections = useSortedFeaturesWithCrs(
    crs,
    clustersToConsider,
    DEFAULT_SORT,
    ddStrength,
    ddSortType,
    diseasesToIncludeInPlan,
    diseasesToRemoveFromPlan,
    diseasesToAdd,
  );

  const inPlanSections = useSortedFeaturesWithCrs(
    crs,
    clustersToConsider,
    DEFAULT_SORT,
    ddStrength,
    DDSortType.BySuspicionIndex,
    diseasesToIncludeInPlan,
    diseasesToRemoveFromPlan,
    diseasesToAdd,
  );

  return { featuresSections, ddData, ddStatus, crs, loading, inPlanSections };
};
